import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdmin } from '@/hooks/useAdmin';
import { useWalletState } from '@/hooks/useWalletState';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAdmin, isInitialized } = useAdmin();
  const { isConnected } = useWalletState();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Add a small delay to ensure wallet and admin status are properly initialized
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  // Show loading spinner while initializing
  if (isLoading || !isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  // Redirect to home if not admin (email admins don't need wallet)
  if (!isAdmin) {
    console.log('Access denied - Connected:', isConnected, 'Admin:', isAdmin);
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
